import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3001";

// Fetch a single catalog metric's data and normalize it to the widget-data
// shape via the entry's map(). These backend endpoints take userId + date range
// as query params (no auth header), matching the rest of the dev-ui data calls.
export async function fetchWidgetData(entry, ctx) {
  const { path, params } = entry.request(ctx);
  const { data } = await axios.get(`${API_BASE}${path}`, { params });
  return entry.map(data || {});
}
